import * as React from "react";
import { iframeResizer } from "iframe-resizer";
import { Button } from "../button/button.mjs";
import { CookieConsentContext } from "../helpers/cookie-consent-provider/cookie-consent-provider.mjs";
import { Heading } from "../typography/heading/heading.mjs";
import { Notice } from "../notice/notice.mjs";
import { Overlay } from "../overlay/overlay.mjs";
import { Text } from "../text/text.mjs";
const _Iframe = class _Iframe extends React.Component {
  constructor(props) {
    super(props);
    this.iframe = null;
    this.handleResize = (data) => {
      if (!this.state.hasLoaded) {
        this.setState({
          hasLoaded: true
        });
      }
      if (this.props.onResize) {
        this.props.onResize(data);
      }
    };
    this.handleLoad = (event) => {
      if (!this.state.hasLoaded) {
        this.setState({
          hasLoaded: true
        });
      }
      if (this.props.onLoad) {
        this.props.onLoad(event);
      }
    };
    this.state = {
      hasLoaded: false
    };
  }
  componentDidMount() {
    this.initResizer();
  }
  componentDidUpdate() {
    this.initResizer();
  }
  componentWillUnmount() {
    var _a;
    if ((_a = this.iframe) == null ? void 0 : _a.iFrameResizer) {
      this.iframe.iFrameResizer.removeListeners();
    }
  }
  BEM() {
    const classArray = ["iframe"];
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  initResizer() {
    const options = {
      checkOrigin: false,
      log: false,
      onResized: this.handleResize
    };
    if (this.iframe && !this.iframe.iFrameResizer) {
      iframeResizer(options, this.iframe);
    }
  }
  renderContent() {
    const { needsConsent, consentHeadingLevel } = this.props;
    if (!this.context.hasConsent(needsConsent)) {
      if (this.context.content) {
        return /* @__PURE__ */ React.createElement("div", { className: "iframe__consent" }, /* @__PURE__ */ React.createElement("div", { className: "iframe__consent-inner" }, /* @__PURE__ */ React.createElement(Notice, { direction: "vertical" }, /* @__PURE__ */ React.createElement(Text, null, /* @__PURE__ */ React.createElement(Heading, { level: consentHeadingLevel, className: "h2" }, this.context.content.title), /* @__PURE__ */ React.createElement("p", { className: "text__margin-double" }, this.context.getDescription(needsConsent)), /* @__PURE__ */ React.createElement("p", { className: "text__margin-double" }, /* @__PURE__ */ React.createElement(Button, { ...this.context.content.button, variant: "secondary", iconRight: "#arrow-right" }))))));
      }
      return null;
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      "iframe",
      {
        ref: (element) => this.iframe = element,
        key: this.props.url,
        src: this.props.url,
        title: this.props.title,
        allow: this.props.allow,
        className: "iframe__content",
        onLoad: this.handleLoad,
        onError: this.props.onError,
        style: { minHeight: this.props.minHeight },
        tabIndex: 0
      }
    ), !this.state.hasLoaded && /* @__PURE__ */ React.createElement(Overlay, { spinner: true }));
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: this.BEM() }, this.renderContent());
  }
};
_Iframe.contextType = CookieConsentContext;
_Iframe.defaultProps = {
  needsConsent: ["necessary"],
  consentHeadingLevel: 1
};
let Iframe = _Iframe;
export {
  Iframe
};
